
import { Link } from 'react-router-dom';

export default function AgeGroupsSection() {
  const programs = [
    {
      id: 'u6',
      title: 'U6 Program',
      age: 'Ages 3-5',
      description: 'Introduction to soccer through fun games and basic skills development. Focus on coordination, listening, and having fun with the ball.',
      features: [
        'Basic ball handling',
        'Simple coordination exercises',
        'Fun games and activities',
        'Social skill development',
        '30-minute sessions'
      ],
      image: 'https://public.readdy.ai/ai/img_res/fda90cef407e63e13324b6d958b23479.jpg',
      color: 'bg-purple-600'
    },
    {
      id: 'u10',
      title: 'U10 Program',
      age: 'Ages 6-9',
      description: 'Building fundamental soccer skills with emphasis on technique, teamwork, and sportsmanship in a supportive environment.',
      features: [
        'Technical skill development',
        'Small-sided games',
        'Teamwork and communication',
        'Basic tactical awareness',
        '45-minute sessions'
      ],
      image: 'https://readdy.ai/api/search-image?query=Children%20ages%207-10%20practicing%20soccer%20drills%20wearing%20purple%20NextZen%20Soccer%20Academy%20jerseys%20with%20cones%20and%20goals%2C%20young%20players%20learning%20passing%20and%20shooting%20techniques%2C%20coaches%20in%20purple%20uniforms%2C%20organized%20training%20session%20with%20coach%20guidance%2C%20professional%20soccer%20field%20setting%2C%20purple%20team%20colors&width=600&height=400&seq=u10-program-purple&orientation=landscape',
      color: 'bg-purple-700'
    },
    {
      id: 'u14',
      title: 'U14 Program',
      age: 'Ages 10-13',
      description: 'Advanced skill development with tactical understanding, competitive play, and character building through challenging training.',
      features: [
        'Advanced technical skills',
        'Tactical understanding',
        'Competitive match play',
        'Leadership development',
        '60-minute sessions'
      ],
      image: 'https://readdy.ai/api/search-image?query=Pre-teen%20soccer%20players%20ages%2011-14%20wearing%20purple%20NextZen%20Soccer%20Academy%20jerseys%20in%20organized%20training%20drills%2C%20advanced%20soccer%20techniques%20practice%2C%20coaches%20in%20purple%20uniforms%2C%20competitive%20youth%20soccer%20training%2C%20professional%20coaching%20on%20regulation%20field%2C%20purple%20team%20colors&width=600&height=400&seq=u14-program-purple&orientation=landscape',
      color: 'bg-purple-800'
    },
    {
      id: 'u18',
      title: 'U18 Program',
      age: 'Ages 14-17',
      description: 'Elite training program preparing players for high school soccer and beyond, with focus on advanced tactics and mental preparation.',
      features: [
        'Elite skill development',
        'Advanced tactical systems',
        'Mental preparation',
        'College prep guidance',
        '75-minute sessions'
      ],
      image: 'https://readdy.ai/api/search-image?query=Teenage%20soccer%20players%20ages%2015-18%20wearing%20purple%20NextZen%20Soccer%20Academy%20jerseys%20in%20intensive%20training%20session%2C%20advanced%20soccer%20drills%20and%20tactical%20exercises%2C%20coaches%20in%20purple%20uniforms%2C%20high-level%20youth%20soccer%20development%2C%20competitive%20training%20environment%2C%20purple%20team%20colors&width=600&height=400&seq=u18-program-purple&orientation=landscape',
      color: 'bg-purple-900'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Age Group Programs
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Tailored training programs designed specifically for each developmental stage
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {programs.map((program) => (
            <div key={program.id} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="relative h-64">
                <img 
                  src={program.image} 
                  alt={program.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className={`absolute top-4 left-4 ${program.color} text-white px-3 py-1 rounded-full text-sm font-semibold`}>
                  {program.age}
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{program.title}</h3>
                <p className="text-gray-600 mb-4">{program.description}</p>
                
                <div className="mb-6">
                  <h4 className="font-semibold text-gray-900 mb-2">Program Features:</h4>
                  <ul className="space-y-1">
                    {program.features.map((feature, index) => (
                      <li key={index} className="flex items-center text-gray-600">
                        <i className="ri-check-line text-purple-600 mr-2"></i>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
                
                <div className="flex gap-3">
                  <Link
                    to="/sessions"
                    className="flex-1 bg-purple-600 text-white text-center py-2 px-4 rounded-lg font-semibold hover:bg-purple-700 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    View Schedule
                  </Link>
                  <Link
                    to="/register"
                    className="flex-1 bg-purple-800 text-white text-center py-2 px-4 rounded-lg font-semibold hover:bg-purple-900 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    Register
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
